module.exports = __webpack_public_path__ + "img/0.b381a949.png";